module.exports = __webpack_public_path__ + "static/media/fb-icon--white.7c705855.svg";